import { Routes } from "@angular/router";
import { ExchangeTokenComponent } from "./page/exchange-token/exchange-token.component";

export const routes: Routes = [
  { path: '', redirectTo: 'web/chatbot', pathMatch: 'full' },
  { path: 'auth/exchange/token', component: ExchangeTokenComponent },
];
